import { render } from "./SelfieGallery.vue?vue&type=template&id=93252572"
import script from "./SelfieGallery.vue?vue&type=script&lang=js"
export * from "./SelfieGallery.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__